exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-stepper-root[data-v-4e6f721a] {\n  display: flex;\n  width: inherit;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  box-sizing: border-box;\n  justify-content: space-between;\n}\n.v-stepper-root *[data-v-4e6f721a],\n.v-stepper-root *[data-v-4e6f721a]::before,\n.v-stepper-root *[data-v-4e6f721a]::after {\n  box-sizing: inherit;\n}", ""]);

// exports
